export default "__VITE_ASSET__Dowpr66e__"